import { IconByType } from 'Containers/Result/utils';

const IconAmount = ({ type }: { type: string }): JSX.Element => {
  const Icon = IconByType[type];
  return (
    <div>
      <Icon />
    </div>
  );
};

export default IconAmount;
